/**
 * Performs a hard browser navigation to a URL outside this router's control
 * (e.g. one of the 2.0 apps served under the same origin).
 *
 * We use `window.location.href` instead of TanStack's `redirect({ href })`
 * because the latter does not trigger a full-document navigation in this setup.
 * The returned promise never resolves so the caller (route loader/beforeLoad)
 * halts here while the browser navigates away, preventing any subsequent
 * redirects, fetches, or component renders from running.
 */
export function hardRedirect(url: string): Promise<never> {
	window.location.href = url;
	return new Promise<never>(() => {});
}
